import { cn } from "@/lib/utils";
import { GalleryVerticalEnd } from "lucide-react";
import optionsIcon from "../../assets/options-icon.png";

interface AuthLayoutProps {
  children: React.ReactNode;
  className?: string;
}

export function AuthLayout({ children, className }: AuthLayoutProps) {
  return (
    <div className="min-h-svh bg-gray-50 sm:bg-gray-100 overflow-y-auto">
      <div className="min-h-svh flex items-center justify-center">
        <div className="w-full flex flex-col items-center justify-center gap-6 py-6 p-4 md:p-10">
          <div className="flex w-full min-w-sm flex-col gap-6 justify-center items-center">
            <h1 className="flex items-center gap-2 self-center text-2xl font-bold">
              {/* <div className="flex h-6 w-6 items-center justify-center rounded-md bg-primary text-primary-foreground">
                <GalleryVerticalEnd className="size-4" />
              </div> */}
              <img src={optionsIcon} alt="Options AI" className="w-9 h-9" />
              Options AI
            </h1>
            {children}
          </div>
        </div>
      </div>
    </div>
  );
}
